import React, { ReactElement } from 'react';
import TextBlock from '../../text-block/text-block.component';
import useStylesHashtagItem from './hashtag-item.styles';

const HashtagItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const LABEL_KEY_DEFAULT: string = 'name';

  const {
    hashtagItem,
    optionItemLabelKey,
  } = props;

  const { classes } = useStylesHashtagItem();

  const labelKey: string = optionItemLabelKey || LABEL_KEY_DEFAULT;

  return (
    <TextBlock className={classes.hashtagItem}>
      {hashtagItem[labelKey]}
    </TextBlock>
  );
});

export default HashtagItem;
